import React, { useContext } from 'react'
import classNames from 'classnames'
import { marked } from 'marked'
import { PageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { TypographyProps } from './Typography.d'

const Typography = ({
  allowHtml = true,
  as = 'div',
  children,
  classes,
  heapInteraction,
  useSmall,
  variation = 'default',
  id
}: TypographyProps) => {
  const Element = as
  const pageContext = useContext(PageContext)

  const typographyClasses = classNames(
    classes,
    {
      'type-display-sm font-medium lg:type-display lg:font-normal':
        variation === 'display' && !useSmall,
      'type-headline-2 lg:type-headline-1 font-medium':
        variation === 'h1' && !useSmall,
      'type-headline-3 lg:type-headline-2 font-medium':
        variation === 'h2' && !useSmall,
      'type-headline-4 font-normal lg:type-headline-3 lg:font-medium':
        variation === 'h3' && !useSmall,
      'type-headline-5 lg:type-headline-4 font-semibold lg:font-normal':
        variation === 'h4' && !useSmall,
      'type-default lg:type-headline-5 font-semibold':
        variation === 'h5' && !useSmall,
      'type-default font-normal': variation === 'default',
      'type-overline font-normal': variation === 'overline',
      'type-caption font-normal': variation === 'caption',
      'font-normal text-[14px]':
        variation === 'statement' &&
        pageContext?.styleContext !== 'request-demo',
      'font-normal text-[12px] first:text-[16px]':
        variation === 'statement' &&
        pageContext?.styleContext === 'request-demo',
      'type-footnote font-normal': variation === 'footnote'
    },
    {
      'type-display-sm font-medium': variation === 'display' && useSmall,
      'type-headline-2 font-medium': variation === 'h1' && useSmall,
      'type-headline-3 font-medium': variation === 'h2' && useSmall,
      'type-headline-4 font-normal': variation === 'h3' && useSmall,
      'type-headline-5 font-normal': variation === 'h4' && useSmall,
      'type-default font-semibold': variation === 'h5' && useSmall
    }
  )

  return (
    <>
      {allowHtml ? (
        <Element
          className={typographyClasses}
          id={id}
          data-interaction={heapInteraction}
          data-testid='mds-typography'
          dangerouslySetInnerHTML={{
            __html: marked.parseInline(children as string)
          }}
        />
      ) : (
        <Element
          className={typographyClasses}
          id={id}
          data-interaction={heapInteraction}
          data-testid='mds-typography'
        >
          {children}
        </Element>
      )}
    </>
  )
}

export default Typography
